var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.393,
    height: 22.785,
    viewBox: "0 0 24.393 22.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .arrowRightWhite{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5867",
    "data-name": "Group 5867",
    transform: "translate(-300.5 -608.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1545",
    "data-name": "Line 1545",
    className: "arrowRightWhite",
    transform: "translate(301.5 619.5)",
    d: "M0 0h22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1546",
    "data-name": "Line 1546",
    className: "arrowRightWhite",
    transform: "translate(316.5 609.5)",
    d: "m0 0 7 10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1548",
    "data-name": "Line 1548",
    className: "arrowRightWhite",
    transform: "translate(316.5 619.5)",
    d: "M0 10 7 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.a757d8f8.svg";
export { ForwardRef as ReactComponent };